var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuiteBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 248,
    y1: 1,
    x2: 248,
    y2: 578.4989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01C7E9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392,173.3V16h104V0H0v16h104v157.3c-10.9,1.4-21.6,2.2-32,2.5v-9.3c9.3-3.3,16-12.1,16-22.5 c0-13.2-10.8-24-24-24s-24,10.8-24,24c0,10.4,6.7,19.2,16,22.5v146.1c-19.1,11.1-32,31.7-32,55.3c0,8.8,7.2,16,16,16h8v16h-8v64 h17.8l8,32h60.5l8-32h227.5l8,32h60.5l8-32H456v-64h-8v-16h8c8.8,0,16-7.2,16-16c0-23.6-12.9-44.3-32-55.3V166.5 c9.3-3.3,16-12.1,16-22.5c0-13.2-10.8-24-24-24s-24,10.8-24,24c0,10.4,6.7,19.2,16,22.5v9.3C413.6,175.5,402.9,174.7,392,173.3z  M120,16h120v16h-72v33.5c-9.3,3.3-16,12.1-16,22.5c0,13.2,10.8,24,24,24s24-10.8,24-24c0-10.4-6.7-19.2-16-22.5V48h56v16h-5.4 l-22.4,56h71.6l-22.4-56H256V48h56v17.5c-9.3,3.3-16,12.1-16,22.5c0,13.2,10.8,24,24,24s24-10.8,24-24c0-10.4-6.7-19.2-16-22.5V32 h-72V16h120v154.9c-20.2-3.5-40.1-8.6-57.1-15c-2.9-1.1-6.2-2.4-9.7-3.8c-16.8-6.8-39.9-16.1-61.2-16.1s-44.3,9.3-61.2,16.1 c-3.5,1.4-6.8,2.7-9.7,3.8c-17.1,6.4-36.9,11.5-57.1,15C120,170.9,120,16,120,16z M184,88c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8 S184,83.6,184,88z M245.4,80h5.2l9.6,24h-24.4L245.4,80z M328,88c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8S328,83.6,328,88z M64,136 c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S59.6,136,64,136z M113.8,480H78.2l-4-16h43.5L113.8,480z M417.8,480h-35.5l-4-16h43.5 L417.8,480z M416,400v16h24v32H56v-32h344v-16H64v-24c0-13.2,10.8-24,24-24h320c13.2,0,24,10.8,24,24v24H416z M456,368h-8.8 c-3.7-18.2-19.9-32-39.2-32H88c-19.3,0-35.5,13.8-39.2,32H40c0-26.5,21.5-48,48-48h320C434.5,320,456,341.5,456,368z M408,304H88 c-5.5,0-10.9,0.8-16,2.1V191.8c36.7-1,78.4-8.8,110.7-20.9c3-1.1,6.4-2.5,10.1-4c15.6-6.3,37-14.9,55.2-14.9s39.6,8.6,55.2,14.9 c3.7,1.5,7,2.8,10.1,4c32.4,12.1,74,19.9,110.7,20.9v114.3C418.9,304.8,413.5,304,408,304z M432,136c4.4,0,8,3.6,8,8s-3.6,8-8,8 s-8-3.6-8-8S427.6,136,432,136z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuiteBlue);
export default __webpack_public_path__ + "static/media/suite-blue.96a2885f7c371a31bbabdbd34ae7971d.svg";
export { ForwardRef as ReactComponent };